export const getInitialState = () => ({
	isSent: false,
	email: '',
	generalErrors: [],
	fieldErrors: {}
});
